module.exports = __webpack_public_path__ + "img/vmc_aniv6_24Aug2021.fae51d09.jpg";